<template>
    <div
        :class="[
            'grid items-center grid-rows-3 investors row-gap-0 col-gap-5 py-6 p-output w-a4w bg-output-gray-200',
            {
                'grid-cols-3':
                    investors.length % 2 !== 0 || investors.length === 8,
                'grid-cols-2':
                    investors.length % 2 === 0 && investors.length !== 8,
                'grid-rows-3': investors.length !== 3,
                'grid-rows-4': investors.length === 3
            }
        ]"
    >
        <div
            v-for="(investor, index) in investors"
            :key="index"
            :class="[
                'w-full p-6 mx-auto bg-white border h-11/12 border-output-primary',
                {
                    'col-span-3 row-span-2 text-3xl ': investors.length === 1,
                    'col-span-1 row-span-2 text-2xl ': investors.length === 2,
                    'row-span-2': investors.length === 3
                }
            ]"
        >
            <h4
                :class="[
                    'text-output-secondary',
                    {
                        'text-xl': investors.length >= 3,
                        'text-3xl': investors.length === 1
                    }
                ]"
            >
                <i
                    v-if="investor.sex === 'femme'"
                    class="las la-female la-lx"
                ></i>
                <i v-else class="las la-male la-lx"></i>
                {{ investor.lastName + " " + investor.firstName }}
            </h4>
            <hr class="w-6/12 h-px bg-output-primary" />
            <div class="grid grid-cols-2 ">
                <div
                    :class="[
                        'pb-1',
                        {
                            ' col-span-2': investors.length < 3
                        }
                    ]"
                >
                    <h4 class="inline pr-1 text-output-secondary">Age :</h4>
                    <p class="inline">{{ age(investor.birthday) }}</p>
                </div>
                <div
                    :class="[
                        'pb-1',
                        {
                            ' col-span-2': investors.length <= 3
                        }
                    ]"
                >
                    <h4 class="inline pr-1 text-output-secondary">CIN :</h4>
                    <p class="inline">{{ investor.CIN }}</p>
                </div>
                <div
                    :class="[
                        'pb-1',
                        {
                            ' col-span-2': investors.length <= 3
                        }
                    ]"
                >
                    <h4 class="inline pr-1 text-output-secondary">
                        <i class="las la-phone text-output-secondary"></i> :
                    </h4>
                    <p class="inline">{{ investor.phone }}</p>
                </div>
                <div
                    :class="[
                        'pb-1',
                        {
                            ' col-span-2': investors.length <= 3
                        }
                    ]"
                >
                    <h4 class="inline pr-1 text-output-secondary">
                        <i class="las la-at text-output-secondary"></i> :
                    </h4>
                    <p class="inline">{{ investor.email }}</p>
                </div>
                <div class="col-span-2 pb-1 ">
                    <h4 class="inline pr-1 text-output-secondary">Adresse :</h4>
                    <p class="inline">{{ investor.address }}</p>
                </div>
                <div class="col-span-2 pb-1 ">
                    <h4 class="inline pr-1 text-output-secondary">
                        Formation :
                    </h4>
                    <p class="inline">{{ investor.niveauDeFormation }}</p>
                </div>
                <div class="col-span-2 pb-1 ">
                    <h4 class="inline pr-1 text-output-secondary">
                        Expérience Professionnelle :
                    </h4>
                    <p class="inline">{{ investor.experiencePro }}</p>
                </div>
                <div class="col-span-2 pb-1 ">
                    <h4 class="inline pr-1 text-output-secondary">
                        Nombre d’années d’experience :
                    </h4>
                    <p class="inline">{{ investor.yearsOfExperience }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        investors: {
            type: Array
            // default: function() {
            //     return [
            // {
            //     firstName: "fdfd",
            //     email: "dffdd@email.com",
            //     CIN: "F56452",
            //     sex: "femme",
            //     experienceProAutre: "",
            //     experiencePro:
            //         "Je dispose d’une expérience professionnelle dans ce domaine",
            //     SituationFamiliale: null,
            //     id: 1606731250984,
            //     formationNeed: [],
            //     niveauDeFormation: "Secondaire",
            //     motivations: [
            //         {
            //             code: "4",
            //             name:
            //                 "Je suis sans emploi, et je veux créer mon propre emploi"
            //         }
            //     ],
            //     address: "dfdfdffddfdf",
            //     phone: "54546546",
            //     mobilite_reduite: false,
            //     birthday: { seconds: 504444400, nanoseconds: 0 },
            //     lastName: "dfdf",
            //     yearsOfExperience: 14,
            //     niveauDeFormationAutre: ""
            // },
            // {
            //     firstName: "fdfd",
            //     email: "dffdd@email.com",
            //     CIN: "F56452",
            //     sex: "femme",
            //     experienceProAutre: "",
            //     experiencePro:
            //         "Je dispose d’une expérience professionnelle dans ce domaine",
            //     SituationFamiliale: null,
            //     id: 1606731250984,
            //     formationNeed: [],
            //     niveauDeFormation: "Secondaire",
            //     motivations: [
            //         {
            //             code: "4",
            //             name:
            //                 "Je suis sans emploi, et je veux créer mon propre emploi"
            //         }
            //     ],
            //     address: "dfdfdffddfdf",
            //     phone: "54546546",
            //     mobilite_reduite: false,
            //     birthday: { seconds: 504444400, nanoseconds: 0 },
            //     lastName: "dfdf",
            //     yearsOfExperience: 14,
            //     niveauDeFormationAutre: ""
            // },
            // {
            //     firstName: "fdfd",
            //     email: "dffdd@email.com",
            //     CIN: "F56452",
            //     sex: "femme",
            //     experienceProAutre: "",
            //     experiencePro:
            //         "Je dispose d’une expérience professionnelle dans ce domaine",
            //     SituationFamiliale: null,
            //     id: 1606731250984,
            //     formationNeed: [],
            //     niveauDeFormation: "Secondaire",
            //     motivations: [
            //         {
            //             code: "4",
            //             name:
            //                 "Je suis sans emploi, et je veux créer mon propre emploi"
            //         }
            //     ],
            //     address: "dfdfdffddfdf",
            //     phone: "54546546",
            //     mobilite_reduite: false,
            //     birthday: { seconds: 504444400, nanoseconds: 0 },
            //     lastName: "dfdf",
            //     yearsOfExperience: 14,
            //     niveauDeFormationAutre: ""
            // }
            // {
            //     firstName: "fdfd",
            //     email: "dffdd@email.com",
            //     CIN: "F56452",
            //     sex: "femme",
            //     experienceProAutre: "",
            //     experiencePro:
            //         "Je dispose d’une expérience professionnelle dans ce domaine",
            //     SituationFamiliale: null,
            //     id: 1606731250984,
            //     formationNeed: [],
            //     niveauDeFormation: "Secondaire",
            //     motivations: [
            //         {
            //             code: "4",
            //             name:
            //                 "Je suis sans emploi, et je veux créer mon propre emploi"
            //         }
            //     ],
            //     address: "dfdfdffddfdf",
            //     phone: "54546546",
            //     mobilite_reduite: false,
            //     birthday: { seconds: 504444400, nanoseconds: 0 },
            //     lastName: "dfdf",
            //     yearsOfExperience: 14,
            //     niveauDeFormationAutre: ""
            // },
            // {
            //     firstName: "fdfd",
            //     email: "dffdd@email.com",
            //     CIN: "F56452",
            //     sex: "femme",
            //     experienceProAutre: "",
            //     experiencePro:
            //         "Je dispose d’une expérience professionnelle dans ce domaine",
            //     SituationFamiliale: null,
            //     id: 1606731250984,
            //     formationNeed: [],
            //     niveauDeFormation: "Secondaire",
            //     motivations: [
            //         {
            //             code: "4",
            //             name:
            //                 "Je suis sans emploi, et je veux créer mon propre emploi"
            //         }
            //     ],
            //     address: "dfdfdffddfdf",
            //     phone: "54546546",
            //     mobilite_reduite: false,
            //     birthday: { seconds: 504444400, nanoseconds: 0 },
            //     lastName: "dfdf",
            //     yearsOfExperience: 14,
            //     niveauDeFormationAutre: ""
            // }
            //     ];
            // }
            // required: true
        }
    },
    methods: {
        age(birthday) {
            return birthday !== ""
                ? new Date().getFullYear() -
                      new Date(birthday.seconds * 1000).getFullYear()
                : "0";
        }
    }
};
</script>

<style>
.investors {
    height: 895px;
    margin-left: -50px;
}
</style>
